import { render, staticRenderFns } from "./GameHeader.vue?vue&type=template&id=56d02ec6&scoped=true&"
import script from "./GameHeader.vue?vue&type=script&lang=js&"
export * from "./GameHeader.vue?vue&type=script&lang=js&"
import style0 from "./GameHeader.vue?vue&type=style&index=0&id=56d02ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d02ec6",
  null
  
)

export default component.exports